import { LoadingComponentProps } from 'react-loadable';

import { Layout } from 'layouts/Layout';
import { ErrorPage } from 'modules/main/pages/Error';
import { LoadingPage } from 'modules/main/pages/Loading';

export function LoadableLoadingPage({
  error,
  pastDelay,
}: LoadingComponentProps) {
  if (error) {
    return <ErrorPage error={error} />;
  }

  if (pastDelay) {
    return <LoadingPage delay={0} />;
  }

  return <Layout />;
}
